/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-line': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M2.919 17.5L6.912 10l4.563 4.056a1.25 1.25 0 001.95-.375l3.45-6.868-1.137-.563-3.432 6.875-4.562-4.056a1.25 1.25 0 00-1.05-.319 1.25 1.25 0 00-.888.625L2.5 15.625V1.25H1.25V17.5c0 .69.56 1.25 1.25 1.25h16.25V17.5H2.919z"/>'
  }
})
